// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
let firebaseApp;
try {
  firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
} catch (e) {
  console.error('Failed to initialize Firebase (web). Check VITE_FIREBASE_* env vars.', e);
  throw e;
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(firebaseApp);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (optional — never block Auth if Analytics/Installations fails)
let analytics = null;
try {
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(firebaseApp);
  }
} catch (e) {
  console.warn('Firebase Analytics unavailable:', e?.code || e?.message || e);
}
export { analytics };
export const app = firebaseApp;
export default firebaseApp;
